module.exports = __webpack_public_path__ + "static/media/rw-widgets.bc7c4a59.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/react-widgets/fonts/rw-widgets.eot
// module id = 162
// module chunks = 0